import { SMLRouteNames } from '../../../routing/sml/SMLRoutes';

/** The route of the Studio showcase under `/app` (spec 2026-10-10 Studio showcase §4). */
export const MUSIC_VIDEO_DEMO_SEGMENT = 'music-video-demo';

/**
 * The signup intent of the showcase: music24-website and the demo send `?intent=music-video`. The
 * onboarding of the app takes it as `promote` (`signupIntent.ts`).
 */
export const MUSIC_VIDEO_SIGNUP_INTENT = 'music-video';

/** The key of the showcase song in the master player and the footage catalog: there is no catalog item. */
export const SHOWCASE_ITEM_KEY = 'music-video-showcase';

/** The path of the demo; the router adds `/app`. */
export function musicVideoDemoPath(): string {
  return `/${MUSIC_VIDEO_DEMO_SEGMENT}`;
}

/** True for `?embed=1`: the demo inside the frame of music24.com/music-video-maker. Pure. */
export function isMusicVideoDemoEmbed(search: string): boolean {
  return new URLSearchParams(search).get('embed') === '1';
}

/**
 * True when the page is the demo inside a frame of the website. The consent bar of the app does not
 * show there: the page around the frame owns it (the cover maker rule). Pure.
 */
export function isMusicVideoDemoEmbedLocation(location: { pathname: string; search: string }): boolean {
  const path = location.pathname.replace(/\/+$/, '');
  return path.endsWith(`/${MUSIC_VIDEO_DEMO_SEGMENT}`) && isMusicVideoDemoEmbed(location.search);
}

/** The sign-up link of every "Start free" and "Sign up free" of the demo. The address is under `/app`. Pure. */
export function musicVideoSignUpHref(): string {
  const query = new URLSearchParams({ intent: MUSIC_VIDEO_SIGNUP_INTENT });
  return `/app/${SMLRouteNames.auth}?${query.toString()}`;
}
